export default __webpack_public_path__ + "static/media/info-system.9422629c.svg";